// Screen Breakpoints
export const MAX_SMALL_WIDTH = 691
export const MIN_MEDIUM_WIDTH = 692
export const MAX_MEDIUM_WIDTH = 1007
export const MIN_LARGE_WIDTH = 1008
